const Dine_Restaurant_data = [{
    "tabId": "trending",
    "layout": {
        "rows": 1,
        "columns": 10,
        "widgetPadding": {},
        "containerStyle": {
            "containerPadding": {}
        },
        "displayStyle": "FULL_BLEED"
    },
    "stackedDetails": {
        "dineoutRestaurants": {
            "restaurants": [{
                "info": {
                    "id": "439099",
                    "name": "Booze Bay",
                    "rating": {
                        "value": "4.1",
                        "count": 423,
                        "countDescription": "423 Google ratings"
                    },
                    "costForTwo": "₹2000 for two",
                    "cuisines": ["North Indian", "Indian Cuisine"],
                    "locality": "Piplani",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2025-12-11T07:01:13.778",
                        "description": "Ambience",
                        "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2025/12/11/c18afdf1-08ce-49c6-b5a1-9851c286f861_image31227d829a2e2846e98bc7b7be4f1a0d4e.JPG"
                    }],
                    "highlights": ["Alcohol served", "Parking available", "Free wifi", "SwiggyPay accepted"],
                    "locationInfo": {
                        "distanceString": "1.4 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Piplani, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 15% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "15% OFF",
                            "description": "FLAT 15% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 2,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "promoted": true,
                    "adTrackingId": "cid=83fe7349-8f35-424d-8183-75a9df327eb0~~adtrid=9b9e2289-7aab-44cc-b7e1-3871923bd674~~adgrpid=83fe7349-8f35-424d-8183-75a9df327eb0#ag1~~cndid=439099~~bp=9ZolpENiI1dIW6vwP9kzQ1bBK9r1oFxOyLA04S8LniQEA3Zn1lJpzqUEBLGF3oqT+E48+QWQRVIvg1sE9XvU1brLZW1d~~mp=SWIGGY_IN~~bl=DINEOUT~~st=~~srvts=1767187044949~~plid=6063bb22-c5fd-4da9-ad5a-97d86b61ddf4~~plpr=DINEOUT_COLLECTION#LISTING~~zoneid=1006~~cityid=55~~lmd=1024.2997~~collid=116084",
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 15% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 2 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "mediaStyle": {
                        "aspectRatio": 1.7778
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "264901"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/439099/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "688561",
                    "name": "Caffeine Mug Cafe",
                    "rating": {
                        "value": "4.3",
                        "count": 200,
                        "countDescription": "200 Google ratings"
                    },
                    "costForTwo": "₹400 for two",
                    "cuisines": ["Beverages", "Fast Food"],
                    "locality": "Indrapuri",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2023-03-04T17:40:37.602",
                        "url": "v1677951638/cb7bf12608572e850cebd778d5ab8f5c.webp"
                    }],
                    "highlights": ["Parking available", "SwiggyPay accepted", "Pure veg"],
                    "locationInfo": {
                        "distanceString": "2.1 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Indrapuri, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 15% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "15% OFF",
                            "description": "FLAT 15% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 2,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 15% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 2 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vegClassifier": "VEG_CLASSIFIER_VEG",
                    "mediaStyle": {
                        "aspectRatio": 1.7778
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "54637"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/688561/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "828292",
                    "name": "Burger Budds",
                    "rating": {
                        "value": "4.6",
                        "count": 28,
                        "countDescription": "28 Google ratings"
                    },
                    "costForTwo": "₹300 for two",
                    "cuisines": ["Continental", "Finger Food"],
                    "locality": "Piplani",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2025-01-30T11:00:05.848",
                        "name": "Food",
                        "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2025/1/30/b742b0e1-0fb8-4c5c-9941-c14625e61fa5_image173a0cb522d124e8b9e9c4e646e8211dc.JPG"
                    }],
                    "highlights": ["Vegan food", "Parking available", "Free wifi", "Pet friendly", "SwiggyPay accepted", "Pure veg"],
                    "locationInfo": {
                        "distanceString": "2.3 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Piplani, Bhopal"
                    },
                    "offerInfoV2": {
                        "vendorOffer": {
                            "header": "FLAT 10% OFF",
                            "offerLogo": {}
                        },
                        "customerOffer": {
                            "header": "+ 10% off with WELCOME + Up to 10% bank offers",
                            "offerLogo": {}
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 1,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 10% off",
                            "subtitle": "on walk-in",
                            "subtext": "+ 1 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vegClassifier": "VEG_CLASSIFIER_VEG",
                    "mediaStyle": {
                        "aspectRatio": 1.7778
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "457202"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/828292/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "943601",
                    "name": "House Of Candy",
                    "rating": {
                        "value": "3.2",
                        "count": 17,
                        "countDescription": "17 Google ratings"
                    },
                    "costForTwo": "₹500 for two",
                    "cuisines": ["Desserts"],
                    "locality": "Maharana Pratap Nagar",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2024-08-18T07:30:48.248",
                        "name": "image 1 jpg",
                        "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2024/8/18/9f734382-aec6-4543-8749-d4300857f466_20240818T073048683.jpg"
                    }],
                    "highlights": ["Reservation available", "SwiggyPay accepted"],
                    "locationInfo": {
                        "distanceString": "7.6 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Maharana Pratap Nagar, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 25% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "25% OFF",
                            "description": "FLAT 25% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 25
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 4,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "promoted": true,
                    "adTrackingId": "cid=ae029235-3116-4d20-8b1f-b888f59d474a~~adtrid=722c93bf-850d-499d-8220-da8f06ee53d5~~adgrpid=ae029235-3116-4d20-8b1f-b888f59d474a#ag1~~cndid=943601~~bp=ahZqya0l8j19LeyTrMMXIFaWwZSZFs8+YDjSk/ISUhtYfvwU68OiGKgT3d4LYRUz2tMJCFnPEy+Fqll9p3k9RSEaxNiQ~~mp=SWIGGY_IN~~bl=DINEOUT~~st=~~srvts=1767187044949~~plid=6063bb22-c5fd-4da9-ad5a-97d86b61ddf4~~plpr=DINEOUT_COLLECTION#LISTING~~zoneid=1006~~cityid=55~~lmd=5792.15~~collid=116084",
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 25% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 4 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "mediaStyle": {
                        "aspectRatio": 1.7778
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "520670"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/943601/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "734243",
                    "name": "The Grillz",
                    "rating": {
                        "value": "5.0",
                        "count": 3,
                        "countDescription": "3 Google ratings"
                    },
                    "costForTwo": "₹500 for two",
                    "cuisines": ["Chinese", "North Indian"],
                    "locality": "Ayodhya Bypass Road",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2023-07-03T06:32:33.088",
                        "url": "v1688365954/dcf08ebef69686b5f983c9fbd22b261a.jpg"
                    }],
                    "highlights": ["SwiggyPay accepted"],
                    "locationInfo": {
                        "distanceString": "2.1 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Ayodhya Bypass Road, Bhopal"
                    },
                    "offerInfoV2": {
                        "vendorOffer": {
                            "header": "FLAT 10% OFF",
                            "offerLogo": {}
                        },
                        "customerOffer": {
                            "header": "+ 10% off with WELCOME + Up to 10% bank offers",
                            "offerLogo": {}
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 1,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 10% off",
                            "subtitle": "on walk-in",
                            "subtext": "+ 1 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "mediaStyle": {
                        "aspectRatio": 1.7778
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "209302"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/734243/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "686534",
                    "name": "Eighteen Calories - The Healthy Food Cafe",
                    "rating": {
                        "value": "4.5",
                        "count": 20,
                        "countDescription": "20 Google ratings"
                    },
                    "costForTwo": "₹500 for two",
                    "cuisines": ["Continental", "Healthy Food"],
                    "locality": "Indrapuri",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2023-02-28T12:48:41.734",
                        "url": "v1677588522/98748da4698ab2d59f65a654f646a412.webp"
                    }],
                    "highlights": ["SwiggyPay accepted"],
                    "locationInfo": {
                        "distanceString": "2.4 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Indrapuri, Bhopal"
                    },
                    "offerInfoV2": {
                        "vendorOffer": {
                            "header": "FLAT 10% OFF",
                            "offerLogo": {}
                        },
                        "customerOffer": {
                            "header": "+ 10% off with WELCOME + Up to 10% bank offers",
                            "offerLogo": {}
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 1,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 10% off",
                            "subtitle": "on walk-in",
                            "subtext": "+ 1 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "mediaStyle": {
                        "aspectRatio": 1.7778
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "272130"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/686534/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "943600",
                    "name": "House Of Candy",
                    "rating": {
                        "value": "3.2",
                        "count": 17,
                        "countDescription": "17 Google ratings"
                    },
                    "costForTwo": "₹500 for two",
                    "cuisines": ["Desserts"],
                    "locality": "Maharana Pratap Nagar",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2024-08-18T07:30:47.365",
                        "name": "image 1 jpg",
                        "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2024/8/18/0f4d54bd-0b38-44bc-8a80-185568b65839_20240818T073047625.jpg"
                    }],
                    "highlights": ["Reservation available", "SwiggyPay accepted"],
                    "locationInfo": {
                        "distanceString": "8 km",
                        "landmarkName": "DB City Mall",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "DB City Mall, Maharana Pratap Nagar, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 25% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "25% OFF",
                            "description": "FLAT 25% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 25
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 4,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "promoted": true,
                    "adTrackingId": "cid=6e2e99cd-60a7-499e-809d-9c98383c228a~~adtrid=de0b0c02-f2ca-4498-aafa-b0276b7ed0a3~~adgrpid=6e2e99cd-60a7-499e-809d-9c98383c228a#ag1~~cndid=943600~~bp=wj7EZ7SurA4ZzraRPnfJK3LYY/diRiEX/eU4Q616+Dq9aRUdq/Sj5Em+Dz/bGcWCNLGStgXU3Yy9zbSlyQq7ILycxszM~~mp=SWIGGY_IN~~bl=DINEOUT~~st=~~srvts=1767187044949~~plid=6063bb22-c5fd-4da9-ad5a-97d86b61ddf4~~plpr=DINEOUT_COLLECTION#LISTING~~zoneid=1006~~cityid=55~~lmd=6038.4185~~collid=116084",
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 25% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 4 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "mediaStyle": {
                        "aspectRatio": 1.7778
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "520670"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/943600/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "897900",
                    "name": "Taste Of Punjab",
                    "rating": {
                        "value": "4.2",
                        "count": 151,
                        "countDescription": "151 Google ratings"
                    },
                    "costForTwo": "₹300 for two",
                    "cuisines": ["North Indian", "Fast Food"],
                    "locality": "Ayodhya Bypass Road",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2024-05-26T07:31:19.026",
                        "name": "image 3 jpg",
                        "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2024/5/26/42a3dbaf-16e1-4945-9949-14a6bf842629_20240526T073119369.jpg"
                    }],
                    "highlights": ["Reservation available", "Free wifi", "SwiggyPay accepted", "Pure veg"],
                    "locationInfo": {
                        "distanceString": "3.2 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Ayodhya Bypass Road, Bhopal"
                    },
                    "offerInfoV2": {
                        "vendorOffer": {
                            "header": "FLAT 15% OFF",
                            "offerLogo": {}
                        },
                        "customerOffer": {
                            "header": "+ 10% off with WELCOME + Up to 10% bank offers",
                            "offerLogo": {}
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "15% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 15% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 2,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "15% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 15% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 15% off",
                            "subtitle": "on walk-in",
                            "subtext": "+ 2 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vegClassifier": "VEG_CLASSIFIER_VEG",
                    "mediaStyle": {
                        "aspectRatio": 1.7778
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "6361"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/897900/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "350365",
                    "name": "Cake Corner",
                    "rating": {
                        "value": "3.7",
                        "count": 55,
                        "countDescription": "55 Google ratings"
                    },
                    "costForTwo": "₹500 for two",
                    "cuisines": ["Desserts"],
                    "locality": "Indrapuri",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2023-06-05T11:25:32.316",
                        "url": "v1685708217/e684499cfc1281c38afd72925cc4f49b.webp"
                    }],
                    "highlights": ["SwiggyPay accepted", "Pure veg"],
                    "locationInfo": {
                        "distanceString": "2.7 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Indrapuri, Bhopal"
                    },
                    "offerInfoV2": {
                        "vendorOffer": {
                            "header": "FLAT 35% OFF",
                            "offerLogo": {}
                        },
                        "customerOffer": {
                            "header": "+ 10% off with WELCOME + Up to 10% bank offers",
                            "offerLogo": {}
                        },
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 30% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "35% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 35% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 35
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "30% OFF",
                            "description": "FLAT 30% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 30
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 2,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "35% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 35% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 35
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 35% off",
                            "subtitle": "on walk-in",
                            "subtext": "+ 2 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vegClassifier": "VEG_CLASSIFIER_VEG",
                    "mediaStyle": {
                        "aspectRatio": 1.7778
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "10062"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/350365/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "686690",
                    "name": "Momo World",
                    "rating": {
                        "value": "5.0",
                        "count": 5,
                        "countDescription": "5 Google ratings"
                    },
                    "costForTwo": "₹400 for two",
                    "cuisines": ["Tibetan", "Fast Food"],
                    "locality": "Indrapuri",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2023-02-28T13:13:12.106",
                        "url": "v1677589993/4505e1ca9ff60c82c724897df988b7ae.jpg"
                    }],
                    "highlights": ["SwiggyPay accepted", "Pure veg"],
                    "locationInfo": {
                        "distanceString": "2.6 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Indrapuri, Bhopal"
                    },
                    "offerInfoV2": {
                        "vendorOffer": {
                            "header": "FLAT 10% OFF",
                            "offerLogo": {}
                        },
                        "customerOffer": {
                            "header": "+ 10% off with WELCOME + Up to 10% bank offers",
                            "offerLogo": {}
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 1,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 10% off",
                            "subtitle": "on walk-in",
                            "subtext": "+ 1 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vegClassifier": "VEG_CLASSIFIER_VEG",
                    "mediaStyle": {
                        "aspectRatio": 1.7778
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "138262"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/686690/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }],
            "style": {},
            "collectionId": "116084"
        }
    },
    "ctaDetail": {
        "textCta": {
            "link": "swiggydiners://collectiondetails/105702",
            "text": "SEE ALL",
            "type": "DEEPLINK"
        }
    }
}, {
    "tabId": "topRated",
    "layout": {
        "rows": 1,
        "columns": 10,
        "widgetPadding": {},
        "containerStyle": {
            "containerPadding": {}
        },
        "displayStyle": "FULL_BLEED"
    },
    "stackedDetails": {
        "dineoutRestaurants": {
            "restaurants": [{
                "info": {
                    "id": "718341",
                    "name": "Symphony -The Fern Residency",
                    "rating": {
                        "value": "4.2",
                        "count": 1754,
                        "countDescription": "1K+ Google ratings"
                    },
                    "costForTwo": "₹900 for two",
                    "cuisines": ["Chinese", "North Indian"],
                    "locality": "Maharana Pratap Nagar",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2023-05-26T10:36:36.808",
                        "url": "v1685097398/6bffaadddaf9b6e99c68e87687a0e267.jpg"
                    }],
                    "highlights": ["Parking available", "SwiggyPay accepted"],
                    "locationInfo": {
                        "distanceString": "6.7 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Maharana Pratap Nagar, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 50% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_LATER",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available 3 Jan"
                            }, {
                                "header": "FLAT 25% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "15% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 15% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "50% OFF",
                            "description": "FLAT 50% OFF",
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_LATER",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available 3 Jan",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 50
                            }
                        }, {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "25% OFF",
                            "description": "FLAT 25% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 25
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 3,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }, {
                            "logoCtx": {
                                "text": "Buffet",
                                "logo": "dineout/rx-card/highlights/bell.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "15% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 15% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "promoted": true,
                    "adTrackingId": "cid=ec1ad2e8-c454-463c-9849-f1736715020d~~adtrid=1658a19c-1dbd-4edf-a914-cf492290012a~~adgrpid=ec1ad2e8-c454-463c-9849-f1736715020d#ag1~~cndid=718341~~bp=AQwsskA8lCVbS9w2JNlNu2UjkRr4nw86IKantabFGab719cBozCmOGSR1vnmaRDjYWHGP2K3toxS2cESxd+G5lTNwXPm~~mp=SWIGGY_IN~~bl=DINEOUT~~st=~~srvts=1767187044965~~plid=6063bb22-c5fd-4da9-ad5a-97d86b61ddf4~~plpr=DINEOUT_COLLECTION#LISTING~~zoneid=1006~~cityid=55~~lmd=4791.8647~~collid=116083",
                    "restaurantTags": ["abc123"],
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 50% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 3 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }, {
                        "logo": {
                            "logo": "dineout/rx-card/highlights/bell.png"
                        },
                        "title": "Buffet",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "739135"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/718341/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "439099",
                    "name": "Booze Bay",
                    "rating": {
                        "value": "4.1",
                        "count": 423,
                        "countDescription": "423 Google ratings"
                    },
                    "costForTwo": "₹2000 for two",
                    "cuisines": ["North Indian", "Indian Cuisine"],
                    "locality": "Piplani",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2025-12-11T07:01:13.778",
                        "description": "Ambience",
                        "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2025/12/11/c18afdf1-08ce-49c6-b5a1-9851c286f861_image31227d829a2e2846e98bc7b7be4f1a0d4e.JPG"
                    }],
                    "highlights": ["Alcohol served", "Parking available", "Free wifi", "SwiggyPay accepted"],
                    "locationInfo": {
                        "distanceString": "1.4 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Piplani, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 15% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "15% OFF",
                            "description": "FLAT 15% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 2,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 15% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 2 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "264901"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/439099/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "688561",
                    "name": "Caffeine Mug Cafe",
                    "rating": {
                        "value": "4.3",
                        "count": 200,
                        "countDescription": "200 Google ratings"
                    },
                    "costForTwo": "₹400 for two",
                    "cuisines": ["Beverages", "Fast Food"],
                    "locality": "Indrapuri",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2023-03-04T17:40:37.602",
                        "url": "v1677951638/cb7bf12608572e850cebd778d5ab8f5c.webp"
                    }],
                    "highlights": ["Parking available", "SwiggyPay accepted", "Pure veg"],
                    "locationInfo": {
                        "distanceString": "2.1 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Indrapuri, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 15% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "15% OFF",
                            "description": "FLAT 15% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 2,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 15% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 2 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vegClassifier": "VEG_CLASSIFIER_VEG",
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "54637"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/688561/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "821446",
                    "name": "Lamington Cafe Patisserie",
                    "rating": {
                        "value": "4.0",
                        "count": 104,
                        "countDescription": "104 Google ratings"
                    },
                    "costForTwo": "₹1000 for two",
                    "cuisines": ["Fast Food"],
                    "locality": "Arera Colony",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2024-12-07T21:16:34.875",
                        "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2024/12/8/9be1b021-143b-41a6-bb66-9dcd419b1ffb_11282d69f82eb4498085e6ff12fd586f6c.JPG"
                    }],
                    "highlights": ["Reservation available", "SwiggyPay accepted", "Pure veg"],
                    "locationInfo": {
                        "distanceString": "9.4 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Arera Colony, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 20% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "20% OFF",
                            "description": "FLAT 20% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 20
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 2,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "promoted": true,
                    "adTrackingId": "cid=b02e6c5d-56a6-44ad-a863-df1ab2b32640~~adtrid=f1a98b26-b364-4435-89c4-6b67f9056ba1~~adgrpid=b02e6c5d-56a6-44ad-a863-df1ab2b32640#ag1~~cndid=821446~~bp=3ljCaeizRT9PXBBUOFg2gOxMiELFyy6yP3+9Xm+qvMLzQJfE/Ef5u4kzHxEeOtJprfFHO9sClC7v5ve0Dfl8DRqG3xHH~~mp=SWIGGY_IN~~bl=DINEOUT~~st=~~srvts=1767187044965~~plid=6063bb22-c5fd-4da9-ad5a-97d86b61ddf4~~plpr=DINEOUT_COLLECTION#LISTING~~zoneid=1006~~cityid=55~~lmd=7057.0547~~collid=116083",
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 20% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 2 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vegClassifier": "VEG_CLASSIFIER_VEG",
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "490141"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/821446/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "805368",
                    "name": "Swastik Pure Veg",
                    "rating": {
                        "value": "4.1",
                        "count": 996,
                        "countDescription": "996 Google ratings"
                    },
                    "costForTwo": "₹1200 for two",
                    "cuisines": ["Chinese", "North Indian"],
                    "locality": "BHEL",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2023-12-15T14:04:45.190",
                        "name": "IMG-20231211-WA0001---Kush-Khatri jpg",
                        "url": "v1702649087/2b82194836eb5c31ef0fb97617c9d4a2.jpg"
                    }],
                    "highlights": ["Reservation available", "SwiggyPay accepted", "Pure veg"],
                    "locationInfo": {
                        "distanceString": "2.5 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "BHEL, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 20% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "20% OFF",
                            "description": "FLAT 20% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 20
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 3,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 20% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 3 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vegClassifier": "VEG_CLASSIFIER_VEG",
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "199123"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/805368/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "880248",
                    "name": "SHUBH SHALEEN SPRINGS",
                    "rating": {
                        "value": "4.4",
                        "count": 917,
                        "countDescription": "917 Google ratings"
                    },
                    "costForTwo": "₹500 for two",
                    "cuisines": ["North Indian", "Chinese"],
                    "locality": "Patel Nagar",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2024-09-26T09:24:56.039",
                        "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2024/9/26/d028c3eb-5cf1-4526-8a01-9942eeb7b1c9_image33fe54905365f400983ccf80e3e089cfe.JPG"
                    }],
                    "highlights": ["Jain food", "Vegan food", "Reservation available", "Parking available", "Smoking area", "SwiggyPay accepted", "Pure veg"],
                    "locationInfo": {
                        "distanceString": "2.5 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Patel Nagar, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 30% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "30% OFF",
                            "description": "FLAT 30% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 30
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 3,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 30% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 3 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vegClassifier": "VEG_CLASSIFIER_VEG",
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "516076"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/880248/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "1052069",
                    "name": "Dhaba Estd 1986",
                    "rating": {
                        "value": "4.0",
                        "count": 125,
                        "countDescription": "125 Google ratings"
                    },
                    "costForTwo": "₹1700 for two",
                    "cuisines": ["North Indian", "Mughlai"],
                    "locality": "Maharana Pratap Nagar",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2025-07-28T07:25:04.066",
                        "description": "Ambience",
                        "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2025/7/28/16d17a1d-ee43-4982-b686-330c39672fbe_image278d21cf22cb3e437ab00bdf5b848f51aa.JPG"
                    }],
                    "highlights": ["Reservation available", "SwiggyPay accepted"],
                    "locationInfo": {
                        "distanceString": "7.6 km",
                        "landmarkName": "DB City Mall",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "DB City Mall, Maharana Pratap Nagar, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 20% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "15% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 15% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "20% OFF",
                            "description": "FLAT 20% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 20
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 4,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "15% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 15% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "promoted": true,
                    "adTrackingId": "cid=a795564e-aff7-430c-b42f-b707f1d2a65c~~adtrid=debcedca-1e08-4741-b077-f741005a9e9a~~adgrpid=a795564e-aff7-430c-b42f-b707f1d2a65c#ag1~~cndid=1052069~~bp=0tbiN2oSkgaTYKwifTE8sLHHeynykwxRCF9EMrA6733pS4PK8jrBPdBJ+5/iNblN+gWhjD7W05ULtUeGepPYrsLFAL2q~~mp=SWIGGY_IN~~bl=DINEOUT~~st=~~srvts=1767187044965~~plid=6063bb22-c5fd-4da9-ad5a-97d86b61ddf4~~plpr=DINEOUT_COLLECTION#LISTING~~zoneid=1006~~cityid=55~~lmd=5741.5796~~collid=116083",
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 20% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 4 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "644032"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/1052069/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "350365",
                    "name": "Cake Corner",
                    "rating": {
                        "value": "3.7",
                        "count": 55,
                        "countDescription": "55 Google ratings"
                    },
                    "costForTwo": "₹500 for two",
                    "cuisines": ["Desserts"],
                    "locality": "Indrapuri",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2023-06-05T11:25:32.316",
                        "url": "v1685708217/e684499cfc1281c38afd72925cc4f49b.webp"
                    }],
                    "highlights": ["SwiggyPay accepted", "Pure veg"],
                    "locationInfo": {
                        "distanceString": "2.7 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Indrapuri, Bhopal"
                    },
                    "offerInfoV2": {
                        "vendorOffer": {
                            "header": "FLAT 35% OFF",
                            "offerLogo": {}
                        },
                        "customerOffer": {
                            "header": "+ 10% off with WELCOME + Up to 10% bank offers",
                            "offerLogo": {}
                        },
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 30% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "35% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 35% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 35
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "30% OFF",
                            "description": "FLAT 30% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 30
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 2,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "35% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 35% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 35
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 35% off",
                            "subtitle": "on walk-in",
                            "subtext": "+ 2 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vegClassifier": "VEG_CLASSIFIER_VEG",
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }],
                    "parentId": "10062"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/350365/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "787283",
                    "name": "PBR Cafe & Restro",
                    "rating": {
                        "value": "4.2",
                        "count": 111,
                        "countDescription": "111 Google ratings"
                    },
                    "costForTwo": "₹1000 for two",
                    "cuisines": ["Biryani", "North Indian"],
                    "locality": "Indrapuri",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2025-01-17T06:00:04.990",
                        "description": "Ambience",
                        "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2025/1/17/83f92790-2bca-4094-bfb1-98dbcd6a4fbf_image134b99a9b2fc88419f8b94cfe22ce85e08.JPG"
                    }],
                    "highlights": ["SwiggyPay accepted"],
                    "locationInfo": {
                        "distanceString": "2.9 km",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "Indrapuri, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 10% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% OFF",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 1
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 10% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 1 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "parentId": "488281"
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/787283/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }, {
                "info": {
                    "id": "846585",
                    "name": "Sankalp",
                    "rating": {
                        "value": "4.0",
                        "count": 89,
                        "countDescription": "89 Google ratings"
                    },
                    "costForTwo": "₹1000 for two",
                    "cuisines": ["Chinese", "South Indian"],
                    "locality": "Maharana Pratap Nagar",
                    "mediaFiles": [{
                        "type": "IMAGE",
                        "id": "2024-06-11T09:19:01.581",
                        "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2024/6/11/7767aaa4-b3af-4744-9e6d-16a5f948c939_IMG1136c06d365a364446980a641a249ad0db.JPG"
                    }],
                    "highlights": ["Reservation available", "Parking available", "SwiggyPay accepted", "Pure veg"],
                    "locationInfo": {
                        "distanceString": "7.9 km",
                        "landmarkName": "DB City Mall",
                        "city": {
                            "name": "Bhopal"
                        },
                        "formattedAddress": "DB City Mall, Maharana Pratap Nagar, Bhopal"
                    },
                    "offerInfoV2": {
                        "otherOffers": {
                            "logo": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "offers": [{
                                "header": "FLAT 20% OFF",
                                "offerLogo": {},
                                "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                                "dealCategory": "Pre-Book",
                                "availabilityDescription": "Available today"
                            }]
                        }
                    },
                    "vendorOffer": {
                        "info": {
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "20% OFF",
                            "description": "FLAT 20% OFF",
                            "isOfferApplicableNow": true,
                            "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                            },
                            "dealCategory": "Pre-Book",
                            "availabilityDescription": "Available today",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 20
                            }
                        }],
                        "infos": [{
                            "header": "Get extra 10% off using WELCOME",
                            "description": " 10% off with WELCOME + Up to 10% bank offers",
                            "coupon": {
                                "code": "WELCOME"
                            },
                            "otherLogoContext": {
                                "logo": "OFFER_LOGO"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "offerCount": 2,
                        "offerHighlights": [{
                            "logoCtx": {
                                "text": "Table booking",
                                "logo": "dineout/rx-card/highlights/book.png"
                            }
                        }],
                        "vendorOfferInfos": [{
                            "header": "TODAY'S \nDISCOUNT",
                            "type": "FLAT",
                            "title": "10% Off",
                            "subtitle": "on total bill",
                            "description": "FLAT 10% OFF",
                            "isOfferApplicableNow": true,
                            "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant's discretion."],
                            "offerType": "OFFER_TYPE_V2_REGULAR",
                            "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                            "offersLogoV2": [{
                                "logo": "dineout/rx-card/OFFER.png",
                                "type": "LOGO_TYPE_RX_TILE"
                            }, {
                                "logo": "dineout/search/as/Offers.png",
                                "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                            }, {
                                "type": "LOGO_TYPE_PAY_BILL"
                            }],
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }]
                    },
                    "customerOffer": {
                        "info": {
                            "description": "+ Up to 10% bank offers",
                            "otherLogoContext": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                            },
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        },
                        "loyaltyInfo": {
                            "cta": {
                                "link": "swiggy://fusion-landing?id=SWIGGY_ONE_NEVER",
                                "text": "Buy Swiggy One",
                                "type": "DEEPLINK"
                            },
                            "offerDetail": {
                                "type": "FLAT",
                                "title": "₹150 Off",
                                "subtitle": "above ₹1500",
                                "description": " ₹150 off",
                                "logoContext": {
                                    "text": "with",
                                    "logo": "ONE"
                                },
                                "coupon": {
                                    "availableCouponCount": 2
                                },
                                "otherLogoContext": {
                                    "logo": "OFFER_LOGO"
                                },
                                "discountInfo": {
                                    "discountType": "DISCOUNT_TYPE_FLAT",
                                    "discountValue": 150
                                }
                            },
                            "oneBenefit": {
                                "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                            }
                        },
                        "otherOffersInfo": [{
                            "header": "ADDITIONAL OFFERS",
                            "type": "CASHBACK",
                            "title": "10%*",
                            "logoContext": {},
                            "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                            "coupon": {},
                            "adjoiningSubtext": "Above ₹100",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 10
                            }
                        }],
                        "infos": [{
                            "description": "Up to 10% off with bank offers",
                            "discountInfo": {
                                "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                                "discountValue": 15
                            }
                        }],
                        "offerCount": 1
                    },
                    "isPaymentAccepted": true,
                    "promoted": true,
                    "adTrackingId": "cid=d55d49f3-72cd-4623-b4bb-06f96b09c906~~adtrid=42a2ee3c-5db6-4ce4-bf20-f283f0d7b347~~adgrpid=d55d49f3-72cd-4623-b4bb-06f96b09c906#ag1~~cndid=846585~~bp=Gui0E2Ba0srl/GBkt/FaTx8rip4wXyzTkUC5g52zCRfcvXONYTUgE4QK9QdCBm8EBvMi5hzv89g6CVsONtTEJpLwqyqS~~mp=SWIGGY_IN~~bl=DINEOUT~~st=~~srvts=1767187044965~~plid=6063bb22-c5fd-4da9-ad5a-97d86b61ddf4~~plpr=DINEOUT_COLLECTION#LISTING~~zoneid=1006~~cityid=55~~lmd=5758.5327~~collid=116083",
                    "offerInfoV3": {
                        "offerLogo": {
                            "logo": "dineout/rx-card/OFFER.png"
                        },
                        "vendorOffer": {
                            "title": "Flat 20% off",
                            "subtitle": "on pre-booking",
                            "subtext": "+ 2 more",
                            "style": {
                                "textColour": "text_color_highest_emphasis_inverse",
                                "bgColour": "positive"
                            },
                            "subtextStyle": {}
                        },
                        "couponOffer": {
                            "title": "Get extra 10% off using WELCOME",
                            "style": {
                                "textColour": "primary_accent"
                            },
                            "subtextStyle": {}
                        }
                    },
                    "vegClassifier": "VEG_CLASSIFIER_VEG",
                    "vendorHighlights": [{
                        "logo": {
                            "logo": "dineout/rx-card/highlights/book.png"
                        },
                        "title": "Table booking",
                        "style": {
                            "textColour": "text_color_med_emphasis",
                            "bgColour": "background_button_tertiary_low"
                        }
                    }]
                },
                "cta": {
                    "link": "https://www.swiggy.com/restaurants/846585/dineout",
                    "text": "DINERSONE_REST_DETAIL",
                    "type": "DEEPLINK"
                }
            }],
            "style": {},
            "collectionId": "116083"
        }
    },
    "ctaDetail": {
        "textCta": {
            "link": "swiggydiners://collectiondetails/105702",
            "text": "SEE ALL",
            "type": "DEEPLINK"
        }
    }
}];


export default Dine_Restaurant_data;